module.exports = __webpack_public_path__ + "691ef5a58d743bf757605c9a654be543.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fontello/fontello.woff?67495670
// module id = 8039
// module chunks = 0